export default __webpack_public_path__ + "static/media/DSC_0751.f69fcdd5.jpeg";